import React, { ReactNode, useContext } from 'react';
import classNames from 'classnames';

import { FormProvider } from './FormProvider';

interface IProps {
  children: string | ReactNode | ReactNode[];
  for?: string;
  required?: boolean;
}

function FormFieldLabel({ children, required = false, ...props }: IProps) {
  const { isShowingRequiredSymbol } = useContext(FormProvider);

  const className = classNames('novoFormFieldLabel', {
    'novoFormFieldLabel--required': isShowingRequiredSymbol && required,
  });

  if (!props.for) {
    return <p className={className}>{children}</p>;
  }
  return (
    <label htmlFor={props.for} className={className}>
      {children}
    </label>
  );
}

export default FormFieldLabel;
